import { axios } from '../../utilities/axiosClient'
import { Shop } from '../../types/Voucher'

type ShopType = {
  shops: Shop[]
}

export const getMypageShop = (): Promise<ShopType> =>
  axios.get('/api/mypage/shop')
